module.exports = __webpack_public_path__ + "static/media/landingbackground.582be5aa.png";